import _ from 'lodash';

export const drfErrorsNormalizer = (errors) => {
  // Returns a normalised object from a standard DRF error payload.
  // This can then be used directly within react-form
  // formApi.setErrors(drfErrorsNormalizer.field)
  const field_errors = { ...errors };
  field_errors.non_field_errors = undefined;

  return {
    hasError: Object.keys(errors).length > 0,
    fields: field_errors,
    form: errors.non_field_errors ? errors.non_field_errors : []
  };
};

export const getAllErrors = (error, errorType = 'all') => {
  const allErrors = [];

  if (error) {
    let errorValue = null;
    let processError = false;

    if (_.hasIn(error, 'response') && _.hasIn(error.response, 'data')) {
      errorValue = error.response.data;
      processError = true;
    }
    else if (_.isArray(error) || _.isPlainObject(error) || _.isString(error)) {
      errorValue = error;
      processError = true;
    }
    else {
      errorValue = null;
      processError = false;
    }

    if (processError) {
      if (_.isString(errorValue)) {
        // -- Error is a string. Return the error message
        // -- string in an array.
        // ---
        if (!allErrors.includes(errorValue)) {
          allErrors.push(errorValue);
        }
      }
      else if (_.isPlainObject(errorValue)) {
        // -- Error is an object. Loop through the object keys
        // -- and extract the key/value error pairs.
        // ---
        Object.keys(errorValue)
          .forEach((key) => {
            if ((errorType === 'all' || errorType === 'nonField') && (key === 'non_field_errors' || key === 'non-field-error')) {
              // -- For non field errors, the object value can be an array, string
              // -- or a sub-object. Recursively search through the object
              // -- until we obtain the error string value and return the
              // -- message in an array.
              // ---
              const errorItem = errorValue[key];
              const tempErrors = getAllErrors(errorItem, errorType);

              // -- Add the error message string values to this array
              // ---
              tempErrors.forEach((errorMessage) => {
                if (!allErrors.includes(errorMessage)) {
                  allErrors.push(errorMessage);
                }
              });
            }
            else if (errorType === 'all' || errorType === 'field') {
              // -- Add the error field and message to the array
              // ---
              allErrors.push(`${key} - ${errorValue[key]}`);
            }
          });
      }
      else if (_.isArray(errorValue)) {
        // -- Response error is an array of string or objects.
        // -- Loop through the array and extract the error values.
        // ---
        errorValue.forEach((errorItem) => {
          // -- The values in the array can be an object, string or sub-array
          // -- Recursively search through the array until we obtain the error
          // -- string value and return the message in an array.
          // ---
          const tempErrors = getAllErrors(errorItem, errorType);

          // -- Add the error message string values to this array
          // ---
          tempErrors.forEach((errorMessage) => {
            if (!allErrors.includes(errorMessage)) {
              allErrors.push(errorMessage);
            }
          });
        });
      }
    }
  }
  return allErrors;
};

export const getErrors = (error, message) => ({
  message: message || '',
  allErrors: getAllErrors(error, 'all'),
  fieldErrors: getAllErrors(error, 'field'),
  nonFieldErrors: getAllErrors(error, 'nonField')
});
